import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import { COLORS } from "@core/constants";
import { TranslateService } from "@ngx-translate/core";
import Plotly from "plotly.js-dist";

@Component({
    selector: "app-smartfleet-chart",
    templateUrl: "./chart.component.html",
    styleUrls: ["./chart.component.scss"],
    standalone: false
})
export class ChartComponent implements OnInit, OnChanges {
  _layout: Object = [];
  @ViewChild("chart") chartEl: ElementRef;

  @Input() config: Object = {
    responsive: true,
    scrollZoom: true,
    locale: "pt-BR",
    modeBarButtonsToRemove: ["toImage"]
  };
  @Input() data: Array<Object> = [];
  @Input() colorPalette = "blue";
  @Input() set layout(value: Object) {
    this._layout = value;
    this._layout = { ...this._layout, colorway: this.getColors() };
  }

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.data && !changes.data.firstChange) ||
      (changes.layout && !changes.layout.firstChange)
    ) {
      this.updateChart();
    }
  }

  ngAfterViewInit(): void {
    this.buildChart();
  }

  get layout() {
    return this._layout;
  }

  getColors(): Array<string> {
    const colors = [];

    if (this.colorPalette === "blue") {
      colors.push(COLORS.DarkBlue);
      colors.push(COLORS.LightBlue);
      colors.push(COLORS.LightBlueW75);
    } else if (this.colorPalette === "green") {
      colors.push(COLORS.DarkGreen);
      colors.push(COLORS.Green);
      colors.push(COLORS.LightGreen50);
    }

    return colors;
  }

  buildChart(): void {
    const element = this.chartEl.nativeElement;
    Plotly.newPlot(element, this.data, this.layout, this.config).then(() => {
      const annotationText = element.querySelector(
        ".annotation .annotation-text"
      );

      if (annotationText && annotationText.textContent?.includes("total")) {
        annotationText.textContent = annotationText.textContent.replace(
          "total",
          this.translateService.instant("my-fleet-total").toLowerCase()
        );

        const bbox = annotationText.getBBox();
        const parentG = annotationText.parentNode as SVGGElement;

        if (parentG) {
          const currentTransform = parentG.getAttribute("transform");
          const xTranslation = -(bbox.width / 2);

          parentG.setAttribute(
            "transform",
            `${currentTransform} translate(${xTranslation}, 0)`
          );
        }
      }
    });
  }

  updateChart(): void {
    const element = this.chartEl.nativeElement;
    Plotly.purge(element);
    this.buildChart();
  }
}
